import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    const authReq = token
      ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : request;

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // Sessão expirada/ inválida: limpa e manda de volta ao login (evita app "travado").
        // Ignora o próprio endpoint de login (401 ali = credenciais inválidas).
        const isLoginRequest = request.url.includes('/auth/login');
        if (error.status === 401 && !isLoginRequest) {
          this.encerrarSessao();
        }
        return throwError(() => error);
      }),
    );
  }

  private encerrarSessao(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if (!this.router.url.includes('/login')) {
      this.router.navigate(['/login'], { queryParams: { expirado: '1' } });
    }
  }
}
